import { getApiBaseUrl, getAuthToken } from "./baseApi";

export async function uploadImage(file) {
  const baseUrl = getApiBaseUrl();
  const token = getAuthToken();

  const formData = new FormData();
  formData.append("image", file);

  const response = await fetch(`${baseUrl}/upload/image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Upload failed");
  }

  return await response.json();
}

export async function uploadReportPdf(file) {
  const baseUrl = getApiBaseUrl();
  const token = getAuthToken();

  const formData = new FormData();
  formData.append("report", file);

  const response = await fetch(`${baseUrl}/upload/report-pdf`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Upload failed");
  }

  return await response.json();
}

export async function deleteUploadedImage(filename) {
  const baseUrl = getApiBaseUrl();
  const token = getAuthToken();

  const response = await fetch(`${baseUrl}/upload/image/${filename}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Delete failed");
  }

  return await response.json();
}
